module.exports = __webpack_public_path__ + "img/shopping-cart.cf601c2c.svg";